module.exports = __webpack_public_path__ + "static/media/University-of-Sunderland.c517a8a8.png";